import api from './api';

export const getServiceTypes = (caseType?: string) =>
  api.get('/admin/service-types', {
    params: caseType ? { case_type: caseType } : undefined,
  });
export const getServiceType = (id: number) =>
  api.get(`/admin/service-types/${id}`);
export const createServiceType = (data: any) =>
  api.post('/admin/service-types', data);
export const updateServiceType = (id: number, data: any) =>
  api.put(`/admin/service-types/${id}`, data);
export const deleteServiceType = (id: number) =>
  api.delete(`/admin/service-types/${id}`);
